/*eslint-disable*/

var parallexers = [];
var scrollTop;

var spireAttach = function(context) {
  for (var key in Drupal.behaviors) {
    if (typeof Drupal.behaviors[key].attach !== 'undefined') {
      Drupal.behaviors[key].attach(context, drupalSettings);
    }
  }
};

// credit: http://www.javascriptkit.com/javatutors/touchevents2.shtml
function swipedetect(el, callback){

  var touchsurface = el,
    swipedir,
    startX,
    startY,
    distX,
    distY,
    threshold = 150, //required min distance traveled to be considered swipe
    restraint = 100, // maximum distance allowed at the same time in perpendicular direction
    allowedTime = 300, // maximum time allowed to travel that distance
    elapsedTime,
    startTime,
    handleswipe = callback || function(swipedir){};

  touchsurface.addEventListener('touchstart', function(e){
    var touchobj = e.changedTouches[0];
    swipedir = 'none';
    dist = 0;
    startX = touchobj.pageX;
    startY = touchobj.pageY;
    startTime = new Date().getTime(); // record time when finger first makes contact with surface
    //    e.preventDefault()
  }, false);

  touchsurface.addEventListener('touchmove', function(e){
    //  e.preventDefault() // prevent scrolling when inside DIV
  }, false);

  touchsurface.addEventListener('touchend', function(e){
    var touchobj = e.changedTouches[0];
    distX = touchobj.pageX - startX; // get horizontal dist traveled by finger while in contact with surface
    distY = touchobj.pageY - startY; // get vertical dist traveled by finger while in contact with surface
    elapsedTime = new Date().getTime() - startTime; // get time elapsed
    if (elapsedTime <= allowedTime){ // first condition for awipe met
      if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint){ // 2nd condition for horizontal swipe met
        swipedir = (distX < 0)? 'left' : 'right'; // if dist traveled is negative, it indicates left swipe
      }
      else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint){ // 2nd condition for vertical swipe met
        swipedir = (distY < 0)? 'up' : 'down'; // if dist traveled is negative, it indicates up swipe
      }
    }
    handleswipe(swipedir);
    //    e.preventDefault()
  }, false);
}

var SpireModal = {
  modal: null,
  open: false,
  owner: null,
  activeKey: null,

  init: function() {
  },

  _createModal: function () {
    if (jQuery('.spire-modal').length > 0) {
      return;
    }
    var me = this;

    jQuery('<div class="modal-overlay"></div>').appendTo(jQuery('body'));

    me.modal = jQuery('<div class="spire-modal modal" tabindex="-1" role="dialog">' +
      '<div class="modal-dialog modal-content">' +
      '<div class="close-button"><button type="button" class="exit" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&#x2715;</span></button></div>' +
      '<div class="modal-inner-content"></div>' +
      '</div></div>');
    me.modal.appendTo(jQuery('body'));

    jQuery('.modal-overlay').bind('click', function(e) {
      e.preventDefault();
      SpireModal.closeModal();
    });

    jQuery('.spire-modal').bind('click', function(e) {
      me.closeModal();
    });

    jQuery('.modal-dialog').bind('click', function(e) {
      e.stopPropagation();
    });

    jQuery('.spire-modal .exit').bind('click', function() {
      me.closeModal();
    });

    swipedetect(me.modal[0], function(swipedir) {
      if (swipedir === 'left') {
        me.moveLeft();
      }
      else if (swipedir === 'right') {
        me.moveRight();
      }
    });
  },

  closeModal: function() {
    if (this.open === false) {
      return;
    }

    jQuery('body').removeClass('modal-shown');

    if (this.owner) {
      this.owner.trigger("modalClose");
    }
    this.owner = null;
    this.open = false;
  },

  displayModalLoader: function(owner, activeKey) {
    var loader = '<div class="loader"><div class="dotring"><div class="loader-container top"><div class="pipeline"></div></div><div class="loader-container bottom"><div class="pipeline"></div></div></div></div>';
    this.displayModal(owner, activeKey, loader);
  },

  displayModal: function(owner, activeKey, content) {
    if (typeof isNarrow === 'undefined') {
      isNarrow = false;
    }

    jQuery('.modal-dialog').removeClass('narrow');
    this.owner = owner;
    this.activeKey = activeKey;

    this._createModal();

    if (isNarrow) {
      jQuery('.modal-dialog').addClass('narrow');
    }

    jQuery('.spire-modal .modal-inner-content').html(content);
    jQuery('body').addClass('modal-shown');
    this.open = true;
    var bLazy = new Blazy();
    bLazy.revalidate();

  },

  updateModal: function(key, content) {
    if (this.activeKey === key) {
      jQuery('.spire-modal .modal-inner-content').html(content);

      var bLazy = new Blazy();
      bLazy.revalidate();
    }
  },

  moveLeft: function() {
    if (this.owner) {
      this.owner.trigger("modalLeft");
    }
  },

  moveRight: function() {
    if (this.owner) {
      this.owner.trigger("modalRight");
    }
  }
};


(function ($) {

  function headerReset() {
    setTimeout(function () {
      var sticky = $('.main-container > .row > .col-sm-12:first-child.sticky');
      sticky.each(function() {
        $(this).css('position', 'fixed');
        $(this).next().css('margin-top', $(this).height() + 'px');
      });
    }, 200);
  }

  var pushAnalytics = function(cat, action, label) {
    spirePushAnalytics(cat, action, label);
  };

  $.fn.extend({
    animateCss: function (animationName) {
      var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
      this.addClass('animated ' + animationName).one(animationEnd, function() {
        $(this).addClass('animationDone');
        $(this).removeClass('animated ' + animationName);
      });
      return this;
    }
  });

  $(document).on('keyup', function(evt) {
    if (SpireModal.open === true) {
      if (evt.keyCode === 27) {
        SpireModal.closeModal();
      }
      else if (evt.key === "ArrowRight") {
        SpireModal.moveRight();
      }
      else if (evt.key === "ArrowLeft") {
        SpireModal.moveLeft();
      }
    }
  });

  $(document).on('scroll', function() {
    $(document).trigger('page_height_change', 50);
  });

  $(document).on('page_height_change', function(e) {
    var localNav = $('.block-localnavigation');
    var header = $('.main-container > .row > .col-sm-12');
    if ($(window).scrollTop() > 50) {
      $("body").addClass("shrink");
      headerReset();
    }
    else {
      $("body").removeClass("shrink");
    }

    var bodyTop = $('section.col-sm-12').scrollTop();

    var windowTop = $(window).scrollTop();
    var windowHeight = $(window).height();
    var windowBottom = windowTop + windowHeight;

    for (var i = 0; i < parallexers.length; ++i) {
      var item = parallexers[i];
      var elemTop = $(item).offset().top;
      var elemBottom = elemTop + $(item).height();
      var height = $(item).height();

      if (elemTop <= windowBottom && elemBottom > windowTop) {
        var start = elemTop;
        var end = elemBottom + windowHeight;
        var range = end - start;
        var used = windowBottom - start;
        var percent = used / range;

        var offset = 300;

        var top = 0 - offset;
        top = top + (offset * percent);
        $('.b-bg', $(item)).css('margin-top', top + 'px');
        var textContainer = $('.full-hero-text-container, .full_width_image_text_container', $(item));

        if (percent > .5) {
          var tPercent = (percent - .5)/ .5;
          var text = (tPercent * height) / 4;
          var mid = (range * .5);

          textContainer.css('margin-top', text + 'px');
          textContainer.css('opacity', ((1 - (tPercent * 2))));
        }
        else {
          textContainer.css('margin-top', '0');
          textContainer.css('opacity', '1');
        }
      }
    }
  });

  $(".dollar-cta .sp-brick-dollarcta-container")
    .mouseenter(function () {
      $(this).find(".field--name-field-dollar-cta-image-1").css("display", "none");
      $(this).find(".field--name-field-dollar-cta-image-2").css("display", "block");
    })
    .mouseleave(function () {
      $(this).find(".field--name-field-dollar-cta-image-2").css("display", "none");
      $(this).find(".field--name-field-dollar-cta-image-1").css("display", "block");
    });


  $('.info-nav-root .dropdown-toggle').each(function() {
    var dropdown = $(this);
    if (dropdown.text() == 'Search') {
      dropdown.addClass('search-icon');
    }
  });

  var $searchmenu = $('.region-header .block-acquiasearchbox');

  var openSearchForm = function() {
    $('body').addClass('header-search-open');
    openMenu($searchmenu);
    $('.region-header .block-acquiasearchbox input').val('');
    $('.region-header .search--button').addClass('open');
    $('.region-header .block-acquiasearchbox input').focus();
  };

  var closeSearchForm = function() {
    $('body').removeClass('header-search-open');
    closeMenu($searchmenu);
    $('.region-header .search--button').removeClass('open');
  };

  var submitSearchForm = function() {
    $('.region-header .block-acquiasearchbox form').submit();
  };

  var openMenu = function($menu) {
    $menu.addClass('open');

    // Grab the current scroll top so we can reset it.
    scrollTop = parseFloat($('html').scrollTop());
    if(typeof scrollTop === 'undefined' || scrollTop === 0) {
      scrollTop = parseFloat($('body').scrollTop());
    }

    // Now change the background position to fixed to prevent it from scrolling.
    $('.main-container .region-content').css('position', 'fixed');
  };

  var closeMenu = function($menu) {
    $menu.removeClass('open');

    // Set the position back to initial to allow body scrolling.
    $('.main-container .region-content').css('position', 'relative');
    // Now set the scroll top back.
    $('html,body').scrollTop(scrollTop);
  };

  var launchModal = function(modal_id) {
    var modal = jQuery('.modal[data-modal-id="' + modal_id + '"]');
    if (modal.length === 0) {
      return;
    }

    var narrow = false;
    if (modal.hasClass('narrow')) {
      narrow = true;
    }

    SpireModal.displayModal(modal, 'id', modal.html(), narrow);

    $('.modal-dialog .field--name-field-close-button a').each(function() {
      $(this).bind('click', function(e) {
        e.preventDefault();
        SpireModal.closeModal();
      });
    });
  };

  function closeAllMenus() {
    $('.top > .expanded.dropdown').has('.open').removeClass('open');
  }

  $('.block-annualreportblock2019 .header-bottom a').each(function(){
    if (window.location.pathname === $(this).attr('href')) {
      $(this).css('color', '#250E62');
    }
  })

  var assetTarget = ['test'];
  Drupal.behaviors.customerConnectLoginStatus = {
    attach: function(context, settings) {
      // Update the body margin once the page loads.
      if(context === document) {
        var timeout = 500;
        // Mobile seems to take longer to render.
        if($(window).width() <= 768) {
          timeout = 1500;
        }
        setTimeout(function() {
          var sticky = $('.main-container > .row > .col-sm-12:first-child.sticky', context);
          sticky.each(function() {
            $(this).css('position', 'fixed');
            $(this).next().css('margin-top', $(this).height() + 'px');
          });
        }, timeout);
      }

      if(typeof $(this).selectmenu !== 'undefined') {
        $.each($('select'), function () {
          // Target only specific select boxes.
          if($(this).parents('.field--name-panel-selector').length <= 0
            && $(this).parents('.view-information-page-listing').length <= 0
            && $(this).parents('.view-blog-taxonomy-archive').length <= 0
          ) {
            return true;
          }

          // First option is randomly blank sometimes.
          if($(this).children('option').first().val() === '') {
            $(this).children('option').first().remove();
          }

          // Attach selectmenu.
          $(once('selectmenu', $(this)[0]))
          .selectmenu(
            {
              width : '300px',
              // Add change trigger.
              change: function( event, ui) {
                $(this).trigger('change');
              }
            }
          );
        });
      }

      $(once('alt-menus', 'body', context))
      .on('click', function (e) {
        closeAllMenus();
      });

      var modalBodyLoaded = {};

      $('body', context).attr('data-location-scope-id', 'global');
      $('body', context).bind('location-update', function(e, data) {
        if (e.target !== $(this)[0]) {
          return;
        }

        if (data.scope === 'global' && typeof drupalSettings.spireModal !== 'undefined') {
          if (typeof modalBodyLoaded[data.data.zip] === 'undefined') {
            modalBodyLoaded[data.data.zip] = true;
            for (var key in drupalSettings.spireModal.modals) {

              if(!drupalSettings.spireModal.modals.hasOwnProperty(key)) {
                continue;
              }

              if (typeof modalBodyLoaded[key] !== 'undefined') {
                continue;
              }

              var zips = drupalSettings.spireModal.modals[key];
              for (var i = 0; i < zips.length; ++i) {
                if (zips[i] === data.data.zip) {
                  launchModal(key);
                  modalBodyLoaded[key] = true;
                  break;
                }
              }
            }
          }
        }
      });


      $("a[href*=\\#]", context).each(function() {
        var href = $(this).attr('href');
        href = href.substr(1);
        var modal = jQuery('.modal[data-modal-id="' + href + '"]');
        if (modal.length > 0) {
          $(this).bind('click', function(e) {
            e.preventDefault();
            launchModal(href);
          });

        }
      });

      if ($('body', context).length > 0) {
        var $body = $('body');
        $.ajax({url: '/mastatus.php' }).done(function(data) {
          $body.addClass('logged-in-state--' + data);
        });
      }

      var $menu = $('.block-mobilemenuflyout', context);
      var $altmenu = $('.alt .header-bottom > .field--name-field-menu-link', context);
      var $topbar = $('.field--name-field-top-bar', context);
      var $footer = $('.footer', context);

      if (!$menu.length) {
        $menu = $('.header-bottom > .field--name-field-menu-link', context);
      }

      if ($('.mobile-menu--button', context).length > 0) {
        $('.mobile-menu--button', context).click(function(e) {
          e.preventDefault();

          if ($menu.hasClass('open')) {
            closeMenu($menu);
            if ($altmenu.length > 0) {
              closeMenu($altmenu);
            }
            $topbar.removeClass('open');
            $footer.show();
          }
          else {
            openMenu($menu);
            if ($altmenu.length > 0) {
              openMenu($altmenu);
            }
            $topbar.addClass('open');
            $footer.hide();
          }
        });

        $('a.dropdown-toggle', context).bind('click', function(e) {
          var parent = $(this).parents('.has-sub-menu.dropdown');
          var me = $(this);
          var open = me.parent('div').hasClass('open') ? false : true;
          setTimeout(function() {
            if (open) {
              parent.addClass('open');
            }
            else {
              parent.removeClass('open');
            }
          }, 50);
        });
      }

      $('.field--name-field-menu-link', context).each(function() {
        var spireMenu = $('.block-altmenu', $(this));
        var li = $('.menu.nav > li', spireMenu);
        li.addClass('big-menu');

        var top = $('.top', $(this));
        top.append(li);
        spireMenu.detach();
      });


      $('.search--button .open--button', context).bind('click', function(e) {
        e.preventDefault();
        if ($(this).parent('.search--button').hasClass('open')) {
          closeSearchForm();
        }
        else {
          closeMenu($searchmenu);
          openSearchForm();
        }
      });

      $('.region-header .block-acquiasearchbox .search-cta', context).bind('click', function (e) {
        e.preventDefault();
        submitSearchForm();
      });

      $('.view-display-id-more_searches .views-field-name a', context).each(function() {
        var term = drupalSettings.path.currentQuery.search;
        $(this).attr('href', $(this).attr('href').replace('SEARCH_TERM_TOKEN', term));
      });

      $('.region-header .block-acquiasearchbox input', context).bind('keyup', function (e) {
        if (e.keyCode === 27) {
          closeSearchForm();
        }
        else if (e.keyCode === 13) {
          submitSearchForm();
        }
      });

      $('span[data-replace="account-balance"]', context).each(function() {
        var raw_cookie = Cookies.get('SPIRE_PUBLIC_INFO');

        if (raw_cookie === undefined) {
          $(this).replaceWith('');
          return;
        }

        var parsed_cookie = JSON.parse(window.atob(raw_cookie));
        var balance = parsed_cookie["balance"];
        balance = parseFloat(Math.round(balance * 100) / 100).toFixed(2);

        $(this).replaceWith('<span class="final-account-balance">' + balance + '</span>');
      });

      $('span[data-replace="account-due-date"]', context).each(function() {
        var raw_cookie = Cookies.get('SPIRE_PUBLIC_INFO');

        if (raw_cookie === undefined) {
          $(this).replaceWith('');
          return;
        }

        var parsed_cookie = JSON.parse(window.atob(raw_cookie));
        var data = parsed_cookie["dueDate"];
        $(this).replaceWith('<span class="final-account-due-date">' + data + '</span>');
      });

      $(once('parallex', '.component-full-width-hero.animate, .full-width-image.animate', context))
      .each(function() {
        $(this).find('.media img').each(function () {
          $(this).addClass('b-bg');
        });
        parallexers.push($(this));
      });

      // Column Animation.
      document.querySelectorAll('.columns-component.animate .column').forEach(function(el) {
        new Waypoint({
          element: el,
          handler: function(direction) {
            if (!el.classList.contains('animationDone')) {
              $(el).animateCss('fadeIn');
            }
          },
          offset: '85%'
        });
      });

      // Half Width Animation.
      document.querySelectorAll('.half-width-image.animate .sp-brick-halfwidth-image-container').forEach(function(el) {
        new Waypoint({
          element: el,
          handler: function(direction) {
            if (!el.classList.contains('animationDone')) {
              $(el).animateCss('fadeIn');
            }
          },
          offset: '80%'
        });
      });

      // Half Width Image Feature Animation
      document.querySelectorAll('.half-width-image-feature.animate').forEach(function(el) {
        new Waypoint({
          element: el,
          handler: function(direction) {
            var image = el.querySelector('.sp-brick-halfwidth-feature-image-container');
            var text = el.querySelector('.field--name-field-callout-text');

            if (!image.classList.contains('animationDone')) {
              $(image).animateCss('fadeIn');
            }

            if (!text.classList.contains('animationDone')) {
              $(text).animateCss('fadeInRight');
            }
          },
          offset: '80%'
        });
      });

      // Large Image
      document.querySelectorAll('.large-image.animate').forEach(function(el) {
        new Waypoint({
          element: el,
          handler: function(direction) {
            var text = el.querySelector('.sp-brick-large-image-copy-container');

            if (!text.classList.contains('animationDone')) {
              $(text).animateCss('fadeInRight');
            }
          },
          offset: '55%'
        });
      });


      // Brand Asset Downloads
      $(once('asset-hover', '.view-brand-asset-downloads .node--type-brand-asset', context))
      .click(function(e) {
        e.preventDefault();
        $('.view-brand-asset-downloads .node--type-brand-asset').removeClass('download-active');
        $(this).addClass('download-active');
        assetTarget = $(e.target);
      });

      $(once('asset-hover', 'body', context))
      .click(function(e) {
        if (assetTarget[0] != $(e.target)[0]) {
          $('.view-brand-asset-downloads .node--type-brand-asset').removeClass('download-active');
        }
      });

      $('.webform-submission-download-this-asset-form select option:selected', context).each(function() {
        var self = $(this);
        if (self.text() === '- Select -') {
          self.remove();
        }
      });

      var nameasset = "";

      $(once('file-downloader', '.asset_downloads .downloader', context))
      .click(function(e) {
        var file = $(this).attr('data-attr-file');
        nameasset = $(this).attr('data-attr-file-name');
        var ext = $(this).attr('data-attr-file-extension');

        var agree = localStorage.getItem('spire_agree_terms');

        if (agree) {
          pushAnalytics('downloads', ext, nameasset);
          window.location = '/download/brand_asset/' + file;
        }
        else {
          jQuery('.spire-modal').addClass('form-downloader');
          launchModal('downloadform');
          pushAnalytics('form engagement', 'asset form - ' + nameasset, 'form open');
          jQuery('.spire-modal').addClass('form-downloader');

          $(once('webform-modal', '.spire-modal.form-downloader, .spire-modal.form-downloader .exit'))
          .bind('click', function(e) {
            pushAnalytics('form engagement', 'asset form - ' + nameasset, 'form abandoned');
          });

          $(once('webform-submit', '.form-downloader .webform-submission-download-this-asset-form'))
          .submit(function(e) {
            var form = $(this);
            var url = form.attr('action');

            e.preventDefault(); // avoid to execute the actual submit of the form.
            var validStatus = SpireForms.SpireDownloadAsset.checkValidation();

            if (validStatus) {
              $.ajax({
                type: "POST",
                url: url,
                data: form.serialize(), // serializes the form's elements.
                success: function(data) {
                  SpireModal.closeModal();
                  pushAnalytics('form engagement', 'asset form - ' + nameasset, 'form complete');
                  localStorage.setItem('spire_agree_terms', true);
                  window.location = '/download/brand_asset/' + file + '?guidelines=1';
                  pushAnalytics('downloads', ext, nameasset);
                },
                error: function(data) {
                  console.log("ERROR");
                }
              });
            }
          });

          $(once('setup-mdc-dl', '.form-downloader .webform-submission-download-this-asset-form', context))
          .each(function() {
            $('.mdc-text-field', $(this)).each(function() {
              new mdc.textField.MDCTextField($(this)[0]);
            });

            $('.mdc-select', $(this)).each(function() {
              new mdc.select.MDCSelect($(this)[0]);
            });

            $('.mdc-checkbox', $(this)).each(function() {
              //new mdc.checkbox.MDCCheckbox($(this)[0]);
            });

            SpireForms.SpireDownloadAsset.init();
          });
        }
      });

      $('.brick.callout-banner .field--name-field-header-copy, ' +
        '.brick.columns-component .field--name-field-section-header, ' +
        '.brick.component-full-width-hero .field--name-field-fullhero-header-copy, ' +
        '.brick.full-width-image .field--name-field-fullwdthimg-header, ' +
        '.brick.half-width-image .field--name-field-header-copy-hwi, ' +
        '.brick.service-accordion .field--name-field-service-accordion-header, ' +
        '.brick.spire-accordion .field--name-field-accordion-title, ' +
        '.brick.half-width-image-feature .field--name-field-title, ' +
        '.brick.pull-quote .field--name-field-callout-text', context).first().each(function () {
        var displayTitleComponent = $('h1.field--name-field-comp-display-page-title');
        var displayTitleArticle = $('h1.field--name-field-art-display-page-title');
        if (displayTitleComponent.length > 0 || displayTitleArticle.length > 0) {
          return;
        }

        var newTagString = '<h1></h1>';
        var newElem = $(newTagString, {html: $(this).html()});
        $.each(this.attributes, function() {
          newElem.attr(this.name, this.value);
        });
        $(this).replaceWith(newElem);
      });

      $('.brick.columns-component.form-group', context).each(function () {
        var ctaColumns = $('.brick.cta-collection' , $(this));

        if (ctaColumns.length > 4) {
          ctaColumns.each(function () {
            $(this).removeClass('cta-orange cta-white cta-transparent').addClass('cta-tertiary-text');
          });
        }
      });

      if (window.location.hostname.indexOf('ourstory'.toLowerCase()) >= 0) {
        $('.site-logo').attr('href', 'https://www.spireenergy.com/')
        $('.block-mobilemenuflyout a').each(function () {
          if ($(this).attr('href').split('/')[0] === '') {
            $(this).attr('href', 'https://www.spireenergy.com' + $(this).attr('href'))
          }
        })
      }
    }
  };
}(jQuery));
